import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { createAiBuilderChatCopy } from '../utils/aiBuilderChatCopy';

export const useAiBuilderChatCopy = () => {
  const { t } = useTranslation(['build']);

  return useMemo(() => createAiBuilderChatCopy(t), [t]);
};
